module.exports = __webpack_public_path__ + "img/10_76.38230ec9.png";